export default function Testimonials() {
  const testimonials = [
    {
      name: "Sakshi Singh",
      role: "Coffee Enthusiast",
      location: "Delhi",
      content: "Roaffees Café is a hidden gem that perfectly blends style and flavour. Their signature matcha-coffee is a smooth, refreshing fusion — earthy matcha meets bold espresso in the most balanced way. The café has a cozy, modern vibe, ideal for quiet moments or casual catch-ups. A must-visit for coffee lovers looking for something unique and memorable in Delhi.",
      rating: 5
    },
    {
      name: "Neeraj Kansal",
      role: "Regular Customer",
      location: "Delhi",
      content: "I recently visited Roaffees Cafe and had a delightful experience. The Cappuccino Viennese was smooth and rich, with a perfect balance of coffee and foam. The Marocchino Caldo exceeded my expectations with well-balanced flavors. The Korean Bun was freshly baked and delightful! The service was friendly, and the atmosphere was cozy. Can't wait to try more of their offerings!",
      rating: 5
    },
    {
      name: "Sona Praveen",
      role: "First-time Visitor",
      location: "Majnu Ka Tila",
      content: "Visited this cute aesthetic Café in Majnu Ka Tila and absolutely loved the experience! Tried Matcha for the first time and it was surprisingly smooth and well-balanced. Their Tiramisu Latte was the highlight — creamy, rich, and totally dessert-like. And the Nutella Croissant was heavenly — crispy on the outside and soft, chocolatey inside.",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Real reviews from our valued customers — 5.0 rating on Google with 147 reviews
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-stone-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 border border-stone-200">
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>
              
              <div>
                <h4 className="font-semibold text-stone-900">{testimonial.name}</h4>
                <p className="text-sm text-gray-600">{testimonial.role}</p>
                <p className="text-sm text-amber-600">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="https://www.google.com/search?q=roaffees+coffee+matcha" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 bg-amber-600 text-white rounded-full font-semibold hover:bg-amber-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-google-line mr-2"></i>
            Read All 147 Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
}
